const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const getTripDaysFromDates = (start?: string | null, end?: string | null): number => {
  if (!start || !end) return 1;

  const startDate = new Date(start);
  const endDate = new Date(end);

  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) return 1;

  // Compare only calendar dates so time-of-day does not change day count.
  const startUtc = Date.UTC(startDate.getUTCFullYear(), startDate.getUTCMonth(), startDate.getUTCDate());
  const endUtc = Date.UTC(endDate.getUTCFullYear(), endDate.getUTCMonth(), endDate.getUTCDate());

  // Inclusive day count: May 1 to May 3 = 3 days.
  const dayDiffInclusive = Math.floor((endUtc - startUtc) / MS_PER_DAY) + 1;
  return Math.max(1, dayDiffInclusive);
};
